import { ROUTES, type RouteWithCopy, type Route } from '~/constants/routes'

// Any change to navigation should be made in the grove SPA repo as well

export const FOOTER_NAVIGATION: {
  shop: RouteWithCopy[]
  about: RouteWithCopy[]
  values: RouteWithCopy[]
  social: RouteWithCopy[]
  policy: Route[]
} = {
  shop: [
    {
      text: 'Cleaning Essentials',
      to: '/catalog/?category=cleaning-essentials',
    },
    {
      text: 'Home & Pantry',
      to: '/catalog/?category=home-pantry',
    },
    {
      text: 'Personal Care',
      to: '/catalog/?category=personal-care',
    },
    {
      text: 'Health & Wellness',
      to: '/catalog/?category=health-wellness',
    },
    {
      text: 'Baby & Kids',
      to: '/catalog/?category=baby-kids-personal-care',
    },
    {
      text: 'Pet',
      to: '/catalog/?category=pet',
    },
  ],
  about: [
    ROUTES.frequentlyAsked,
    {
      text: 'Blog',
      to: '/g/blog/',
    },
    ROUTES.about,
    ROUTES.careers,
    {
      text: 'Partner Program',
      to: '/s/partners/',
    },
    {
      text: 'Investor Relations',
      to: 'https://investors.grove.co/',
    },
  ],
  values: [
    ROUTES.groveStandard,
    {
      text: 'Sustainability',
      to: '/g/sustainability/',
    },
    {
      text: 'Beyond Plastic',
      to: '/beyondplastic/',
    },
    {
      text: 'Happiness Guarantee',
      to: '/g/shipping-returns/',
    },
    {
      text: 'Accessibility Policy',
      to: '/policies/#accessibility-policy',
    },
  ],
  social: [
    {
      text: 'Facebook',
      to: 'https://www.facebook.com/GroveCollab/',
    },
    {
      text: 'Instagram',
      to: 'https://www.instagram.com/grovecollaborative/',
    },
    {
      text: 'Twitter',
      to: 'https://www.twitter.com/grovecollab/',
    },
    {
      text: 'Pinterest',
      to: 'https://www.pinterest.com/grovecollab/',
    },
    {
      text: 'TikTok',
      to: 'https://www.tiktok.com/@grovecollaborative/',
    },
  ],
  policy: [
    ROUTES.californiaSupplyChain,
    ROUTES.privacy,
    ROUTES.terms,
    ROUTES.policies,
    ROUTES.contactUs,
  ],
}
